import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MedicalRecord } from '../../../models/medical-record';
import { finalize, Subject, takeUntil } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuxiliarService } from '../../../services/auxiliar.service';
import { NGXLogger } from 'ngx-logger';
import { MedicalRecordService } from '../../../services/medical-record.service';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import moment from 'moment';
import { Patient } from '../../../models/patient';

@Component({
  selector: 'app-close-medical-record-drawer',
  standalone: false,
  templateUrl: './close-medical-record-drawer.component.html',
  styleUrl: './close-medical-record-drawer.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CloseMedicalRecordDrawerComponent implements OnInit, OnDestroy {
  @Input() medicalRecord: MedicalRecord | undefined;
  @Input() patient: Patient;

  private destroy$: Subject<boolean> = new Subject<boolean>();
  public form: FormGroup;
  public loading: boolean;
  public today: Date = new Date();

  get f(): { [index: string]: any } {
    return this.form.controls;
  }

  constructor(
    private formBuilder: FormBuilder,
    private auxiliarService: AuxiliarService,
    private logger: NGXLogger,
    private medicalRecordService: MedicalRecordService,
    private translate: TranslateService,
  ){}

  ngOnInit(): void {
    this.loadForm();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private loadForm(): void {
    this.form = this.formBuilder.group({
      closingDate: [this.today, [Validators.required]],
      closingReport: ['', [Validators.required]],
      id: [this.medicalRecord?.id, [Validators.required]],
    });
  }

  public save(): void {
    this.form.markAllAsTouched();
    if (this.form.valid && this.medicalRecord?.patient?.id) {
      this.loading = true;
      const formData = _.cloneDeep(this.form.getRawValue());
      _.set(formData, 'closingDate', moment(formData.closingDate).endOf('day'));
      this.medicalRecordService.updateMedicalRecord(formData, this.medicalRecord.patient.id).pipe(
        finalize(() => this.loading = false),
        takeUntil(this.destroy$)
      ).subscribe({
        next: (res: any) => {
          this.logger.debug('[medicalRecordService] updateMedicalRecord res: ', res);
          this.auxiliarService.toast(this.translate.instant('success.medical-record-close'), 'success');
          this.auxiliarService.closeDrawer('left', _.get(res, 'body'));
        },
        error: (err: any) => {
          this.logger.error('[medicalRecordService] updateMedicalRecord err:', err);
          this.auxiliarService.toast(this.translate.instant('error.medical-record-close'), 'error');
        }
      });
    }
  }

  public cancel(): void {
    this.auxiliarService.closeDrawer('left');
  }
}
